import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Index.vue'
// eslint-disable-next-line no-unused-vars
import store from '@/store'
// import utils from '@/js/utils'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/steps',
    component: () =>
      import(/* webpackChunkName: "steps" */ '../views/gmo/steps/Index.vue'),
    children: [
      {
        path: '/gallery',
        name: 'Gallery',
        component: () =>
          import(/* webpackChunkName: "gallery" */ '../views/gallery/Index.vue')
      },
      {
        path: '/product',
        name: 'Product',
        component: () =>
          import(/* webpackChunkName: "product" */ '../views/product/Index.vue')
      },
      {
        path: '/xianhuo',
        name: 'Xianhuo',
        component: () =>
          import(/* webpackChunkName: "xianhuo" */ '../views/xianhuo/Index.vue')
      },
      {
        path: '/design',
        name: 'Design',
        component: () =>
          import(/* webpackChunkName: "design" */ '../views/design/Index.vue')
      },
      {
        path: '/view3d',
        name: 'View3d',
        component: () =>
          import(/* webpackChunkName: "view3d" */ '../views/view3d/Index.vue')
      },
      {
        path: '/shopcart',
        name: 'ShopCart',
        component: () =>
          import(
            /* webpackChunkName: "shopcart" */ '../views/shopcart/Index.vue'
          )
      },
      {
        path: '/help',
        name: 'Help',
        component: () =>
          import(/* webpackChunkName: "help" */ '../views/gmo/help/Index.vue')
      }
    ]
  },
  {
    path: '/info',
    name: 'Info',
    component: () =>
      import(/* webpackChunkName: "info" */ '../views/info/Index.vue')
  },
  {
    path: '/share',
    name: 'Share',
    component: () =>
      import(/* webpackChunkName: "share" */ '../views/share3d/Index.vue')
  },
  {
    path: '*',
    name: '404',
    component: () =>
      import(/* webpackChunkName: "404" */ '../views/error/Index.vue')
  },
  {
    path: '/webview',
    name: 'Webview',
    component: () =>
      import(/* webpackChunkName: "webview" */ '../views/webview/Index.vue')
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (store.state.ui.firstCome) {
    // 第一次进入，如果不是分享页面，跳转到首页
    let sid = to.query.ps
    if (sid == null) {
      sid = localStorage.getItem('PS') || '0'
    } else {
      localStorage.setItem('PS', sid)
    }
    store.state.brand.sid = sid
    store.state.ui.firstCome = false
    if (sid == null || sid + '' === '0') {
      alert('店No正しくない')
    }
    if (to.name === 'Home') {
      next({ path: '/product', query: { ps: store.state.brand.sid } })
    } else if (to.name !== 'Share' || to.query.id == null) {
      next({ path: '/product', query: { ps: store.state.brand.sid } })
    } else {
      next({ query: { ps: store.state.brand.sid } })
    }
  } else {
    if (to.name === 'Design' && !store.state.design.shareuc.product) {
      // 进入设计页面，但是没有选择产品，跳转到产品页
      next({ path: '/product', query: { ps: store.state.brand.sid } })
    } else {
      next({ query: { ps: store.state.brand.sid } })
    }
  }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
